export const userConstant = {
    USER_LOGIN: "USER_LOGIN",
    USER_AUTHENTICATION: "USER_AUTHENTICATION",
    USER_LOGOUT: "USER_LOGOUT"
    // USER_REGISTER: "USER_REGISTER"
};
